import React from 'react';
import LogoImage from '../../../Assets/kwikmediaLogo.webp';
import {
  LegalPageRoot,
  LegalCard,
  LegalBrandRow,
  LegalLogo,
  LegalDocTitle,
  LegalDocMeta,
  LegalBody,
  LegalSectionHeading,
  LegalSubheading,
  LegalParagraph,
  LegalLink,
} from './LegalDocumentStyles';

const RefundAndRegister = () => {
  return (
    <LegalPageRoot>
      <LegalCard>
        <LegalBrandRow>
          <LegalLogo src={LogoImage} alt="KwikMemories" />
          <LegalDocTitle>Registration &amp; Refund Policy</LegalDocTitle>
          <LegalDocMeta>KwikMemories · Ventureboo LLP</LegalDocMeta>
        </LegalBrandRow>

        <LegalBody>
          <LegalSectionHeading>1. Registration Policy</LegalSectionHeading>

          <LegalSubheading>Account Creation</LegalSubheading>
          <LegalParagraph>
            Users must register with a valid email address, mobile number, and password to access
            KwikMemories services. Users are responsible for maintaining the confidentiality of their
            login credentials.
          </LegalParagraph>

          <LegalSubheading>Eligibility</LegalSubheading>
          <LegalParagraph>
            Users must be at least 18 years of age, or have parental/guardian consent if younger.
            Accounts found with false or misleading information may be suspended or terminated.
          </LegalParagraph>

          <LegalSubheading>Usage</LegalSubheading>
          <LegalParagraph>
            Each account is personal and non-transferable. Users agree to comply with
            KwikMemories&apos;s Terms of Service and not misuse the platform.
          </LegalParagraph>

          <LegalSectionHeading>2. Refund Policy</LegalSectionHeading>
          <LegalParagraph>
            We aim to provide the best experience. However, if you are not satisfied with our paid
            services, the following refund terms apply:
          </LegalParagraph>

          <LegalSubheading>Subscription Plans</LegalSubheading>
          <LegalParagraph>
            Refunds are only available within 7 days of the initial subscription purchase, provided
            no premium features (e.g., storage, editing tools, face recognition scans) have been
            significantly used. Renewal payments (auto-subscriptions) are non-refundable, but users
            may cancel auto-renewal anytime from their account settings.
          </LegalParagraph>

          <LegalSubheading>Photo Storage &amp; Premium Features</LegalSubheading>
          <LegalParagraph>
            Fees paid for additional storage, AI-based features, or one-time credits are
            non-refundable once the service has been consumed or credits used. If purchased but
            unused, users may request a refund within 7 days of purchase.
          </LegalParagraph>

          <LegalSubheading>Technical Issues</LegalSubheading>
          <LegalParagraph>
            If a user experiences technical problems (e.g., payment failure, duplicate charges),
            KwikMemories will verify the issue and issue a refund or credit within 7–10 business days.
          </LegalParagraph>

          <LegalSubheading>No Refunds For</LegalSubheading>
          <LegalParagraph>
            Change of mind after purchase or violations of our Terms of Service leading to account
            suspension or termination.
          </LegalParagraph>

          <LegalSectionHeading>3. Refund Request Process</LegalSectionHeading>
          <LegalParagraph>
            To request a refund, users must contact{' '}
            <LegalLink href="mailto:contact@kwikmemories.com">contact@kwikmemories.com</LegalLink>{' '}
            with payment details, order ID, and reason for refund. Refunds will be processed via the
            original payment method within 7–10 business days, subject to verification.
          </LegalParagraph>

          <LegalSectionHeading>4. Cancellation Policy</LegalSectionHeading>
          <LegalParagraph>
            Users can cancel subscriptions from their account settings to prevent future billing. If
            an account is deleted, users should export any data they want to keep. Data deletion
            requests will be handled in accordance with applicable laws.
          </LegalParagraph>

          <LegalSectionHeading>5. Policy Updates</LegalSectionHeading>
          <LegalParagraph>
            KwikMemories reserves the right to update or modify this policy at any time. Users will
            be notified of significant changes via email or in-app notifications.
          </LegalParagraph>
        </LegalBody>
      </LegalCard>
    </LegalPageRoot>
  );
};

export default RefundAndRegister;
